import { CoverPicture } from 'components';
import renderIcon from 'helpers/renderIcon';
import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IComment } from 'models/common';
import moment = require('moment');

interface IProps {
	showInteractions?: boolean;
	items?: IComment[];

	/* functions props */
	t?: (key: string) => string;
}

interface IState {
	seeMoreArray: number[];
	allExpandableParagraphsArray: number[];
	// to prevent infinite rerender if allExpandableParagraphsArray is empty
	allExpandableParagraphsStopUpdate: boolean;
}

let allExpandableParagraphs: number[] = [];

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ReviewList extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);
		this.addSeeMore = this.addSeeMore.bind(this);
		this.removeSeeMore = this.removeSeeMore.bind(this);
		this.setExpandableParagraphsList = this.setExpandableParagraphsList.bind(this);
		this.state = {
			seeMoreArray: [],
			allExpandableParagraphsArray: [],
			allExpandableParagraphsStopUpdate: false,
		};
	}
	reviewRefArray: HTMLParagraphElement[] = [];

	public setExpandableParagraphsList() {
		allExpandableParagraphs = [];
		this.reviewRefArray.forEach((x, index) => {
			if (x.scrollHeight - x.offsetHeight > 5) {
				// Hack - when using a touchpad, it add 1px to offsetHeight
				allExpandableParagraphs.push(index);
			}
		});
		// setting state only after map, to mitigate unwanted rerenders
		this.setState({
			allExpandableParagraphsArray: allExpandableParagraphs,
			seeMoreArray: [],
			allExpandableParagraphsStopUpdate: true,
		});
	}

	componentDidUpdate(): void {
		// using componentDidMount doesn't work, because reviews are rendered after intial render
		// and refs aren't set yet?
		if (
			!this.state.allExpandableParagraphsStopUpdate &&
			this.reviewRefArray.length &&
			!this.state.allExpandableParagraphsArray.length
		) {
			this.setExpandableParagraphsList();
		}
	}

	componentWillUnmount(): void {
		allExpandableParagraphs = [];
	}

	public addSeeMore(key: number) {
		if (!this.state.seeMoreArray.includes(key)) {
			this.setState({
				seeMoreArray: [...this.state.seeMoreArray, key],
			});
		}
	}
	public removeSeeMore(key: number) {
		if (this.state.seeMoreArray.includes(key)) {
			this.setState({
				seeMoreArray: [...this.state.seeMoreArray.filter((x) => x !== key)],
			});
		}
	}

	render() {
		const { showInteractions, items } = this.props;
		const { seeMoreArray } = this.state;

		const reviews = (): JSX.Element[] => {
			return items?.length
				? items.map((x, index) => {
						return (
							<div key={index} className="review-element">
								<CoverPicture imageUrl={x.addedByPicture ? x.addedByPicture : ''} editFunction={null} />
								<div className="text-container">
									<p className="p14 name">
										<span>{x.addedBy}</span>
										<span className="time">{x.addedDate && moment(x.addedDate).fromNow()}</span>
									</p>
									<div className="single-review-score d-flex flex-row align-items-center">
										{renderIcon('star1', 20, 20)}
										<p>{x.rating}</p>
									</div>
									<div className="body">
										<p
											className={`${seeMoreArray.includes(index) ? 'expanded' : ''}`}
											ref={(ref) => (this.reviewRefArray[index] = ref)}
										>
											{x.body}
										</p>
										{this.state.allExpandableParagraphsArray.includes(index) ? (
											<div className="buttons">
												{seeMoreArray.includes(index) ? (
													<p className="pointer" onClick={() => this.removeSeeMore(index)}>
														{this.props.t('User_UserCard_SeeLess')}
													</p>
												) : (
													<p className="pointer" onClick={() => this.addSeeMore(index)}>
														{this.props.t('User_UserCard_SeeMore')}
													</p>
												)}
											</div>
										) : null}
									</div>
									{showInteractions ? (
										<>
											{renderIcon('edit')}
											<p className="p12">{x.rating}</p>
											{/* //TODO ? Zaenkrat nimamo tega podprtega na APIju */}
										</>
									) : null}
								</div>
							</div>
						);
				  })
				: null;
		};

		return <div className="reviewlist-container">{reviews()}</div>;
	}
}

export default ReviewList;
